import loadable from '@loadable/component'

export default [
  {
    // 世界杯2022主页面
    path: '/WorldCup2022',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-WorldCup2022" */ '~/pages/WorldCup2022'
        )
    ),
  },
]
